export enum DocumentTypeDTO {
    Invoice = 0,
    Receipt = 1
};